<template lang="pug">
  .profile-page__content
    section.profile-page-form__section.profile-section
      .profile-section__title
        h2.profile-section-title Спальные корпуса
      .profile-section__body
        .form
          .form__elem.form__elem_middle
            .form-elem.form-elem_horizontal
              .form-elem__title Название
              .form-elem__main.form__elem_full
                select.select.select_full(
                disabled
                )
                  option(
                  v-for="item in campTypeList"
                    :value="item.value"
                  ) {{item.text}}
          .form__elem.form__elem_short
            .form-elem.form-elem_horizontal
              .form-elem__title Вместимость
              .form-elem__body
                input.input.input_full(
                maxlength="50"
                value="200"
                disabled
                )
          .form__elem.form__elem_short
            .form-elem.form-elem_horizontal
              .form-elem__title Размещение
              .form-elem__body
                input.input.input_small(
                maxlength="50"
                value="10"
                )
                span.form-elem__label Местное
          .form__elem
            .form-elem.form-elem_horizontal
              .form-elem__title Дополнительная информация
              .form-elem__body
                input.input.input_full(
                maxlength="50"
                value="Английская"
                )
          .form__elem.form__elem_full
            .photo-upload
              .photo-upload__title Фотографии
              .photo-upload__text Размер фото не больше 3мб
              .photo-upload__container
                .photo-upload__img
                  img(src="@/assets/images/photo-upload-test/1.jpg")
                .photo-upload__img
                  img(src="@/assets/images/photo-upload-test/2.jpg")
                .photo-upload__img
                  img(src="@/assets/images/photo-upload-test/3.jpg")
                .photo-upload__img
                  img(src="@/assets/images/photo-upload-test/4.jpg")
                .photo-upload__img
                  img(src="@/assets/images/photo-upload-test/5.jpg")
                //.photo-upload__img
                  img(src="@/assets/images/photo-upload-test/6.jpg")
                .photo-upload__button.button.button_paint-main--light
                  .button__icon
                    img(src="@/assets/images/icons/clip.svg")
                  .button__text Добавить файл

      hr.profile-section__separator

      .profile-section__body
        .form
          .form__elem.form__elem_middle
            .form-elem.form-elem_horizontal
              .form-elem__title Название
              .form-elem__main.form__elem_full
                select.select.select_full(
                disabled
                )
                  option Кирпичный
                  option Деревянный
          .form__elem.form__elem_short
            .form-elem.form-elem_horizontal
              .form-elem__title Вместимость
              .form-elem__body
                input.input.input_full(
                maxlength="50"
                value="200"
                disabled
                )
          .form__elem.form__elem_short
            .form-elem.form-elem_horizontal
              .form-elem__title Размещение
              .form-elem__body
                input.input.input_small(
                maxlength="50"
                value="5,6"
                )
                span.form-elem__label Местное
          .form__elem
            .form-elem.form-elem_horizontal
              .form-elem__title Дополнительная информация
              .form-elem__body
                input.input.input_full(
                maxlength="50"
                value="Английская"
                )
          .form__elem.form__elem_full
            .photo-upload
              .photo-upload__title Фотографии
              .photo-upload__text Размер фото не больше 3мб
              .photo-upload__container
                .photo-upload__img
                  img(src="@/assets/images/photo-upload-test/1.jpg")
                .photo-upload__img
                  img(src="@/assets/images/photo-upload-test/2.jpg")
                .photo-upload__img
                  img(src="@/assets/images/photo-upload-test/3.jpg")
                .photo-upload__img
                  img(src="@/assets/images/photo-upload-test/4.jpg")
                .photo-upload__img
                  img(src="@/assets/images/photo-upload-test/5.jpg")
                //.photo-upload__img
                  img(src="@/assets/images/photo-upload-test/6.jpg")
                .photo-upload__button.button.button_paint-main--light
                  .button__icon
                    img(src="@/assets/images/icons/clip.svg")
                  .button__text Добавить файл

    section.profile-page-form__section.profile-section
      .profile-section__title
        h2.profile-section-title Питание
      .profile-section__body
        .form
          .form__elem
            .form-elem.form-elem_horizontal
              .form-elem__title Дополнительная информация
              .form-elem__body
                input.input.input_full(
                maxlength="50"
                value="5-и разовое питание"
                )
          .form__elem
            .form-elem.form-elem_horizontal
              .form-elem__title
              .form-elem__body
                input.input.input_full(
                maxlength="50"
                value="Столовая вмещает  200 человек"
                )
          .form__elem.form__elem--align-right
            button.button.button_paint-main--light
              //.button__icon
                img(src="@/assets/images/icons/clip.svg")
              .button__text Добавить пункт
          .form__elem.form__elem_full
            .photo-upload
              .photo-upload__title Фотографии
              .photo-upload__text Размер фото не больше 3мб
              .photo-upload__container
                .photo-upload__img
                  img(src="@/assets/images/photo-upload-test/1.jpg")
                .photo-upload__img
                  img(src="@/assets/images/photo-upload-test/2.jpg")
                .photo-upload__img
                  img(src="@/assets/images/photo-upload-test/3.jpg")
                .photo-upload__img
                  img(src="@/assets/images/photo-upload-test/4.jpg")
                .photo-upload__img
                  img(src="@/assets/images/photo-upload-test/5.jpg")
                //.photo-upload__img
                  img(src="@/assets/images/photo-upload-test/6.jpg")
                .photo-upload__button.button.button_paint-main--light
                  .button__icon
                    img(src="@/assets/images/icons/clip.svg")
                  .button__text Добавить файл

    section.profile-page-form__section.profile-section
      .profile-section__title
        h2.profile-section-title Зоны гигиенического ухода
      .profile-section__body
        .form
          .form__elem.form__elem_middle
            .form-elem.form-elem_horizontal
              .form-elem__title Название
              .form-elem__main.form__elem_full
                select.select.select_full
                  option На этаже
                  option Не на этаже
          .form__elem
            .form-elem.form-elem_horizontal
              .form-elem__title Расположение
              .form-elem__body
                input.input.input_full(
                maxlength="50"
                value="Рукомойники и ногомойники с горячей водой"
                )
          .form__elem
            .form-elem.form-elem_horizontal
              .form-elem__title
              .form-elem__body
                input.input.input_full(
                maxlength="50"
                value="Душ на улице у озера"
                )
          .form__elem.form__elem--align-right
            button.button.button_paint-main--light
              //.button__icon
                img(src="@/assets/images/icons/clip.svg")
              .button__text Добавить пункт

          .form__elem.form__elem_full
            .photo-upload
              .photo-upload__title Фотографии
              .photo-upload__text Размер фото не больше 3мб
              .photo-upload__container
                .photo-upload__button.button.button_paint-main--light
                  .button__icon
                    img(src="@/assets/images/icons/clip.svg")
                  .button__text Добавить файл

    section.profile-page-form__section.profile-section
      .profile-section__title
        h2.profile-section-title Площадки для творчества
      .profile-section__body
        .form
          .form__elem
            .form-elem.form-elem_horizontal
              .form-elem__title Название
              .form-elem__body
                input.input.input_full(
                maxlength="50"
                value="Актовый зал"
                )
          .form__elem
            .form-elem.form-elem_horizontal
              .form-elem__title
              .form-elem__body
                input.input.input_full(
                maxlength="50"
                value="Актовый зал"
                )
          .form__elem.form__elem--align-right
            button.button.button_paint-main--light
              //.button__icon
                img(src="@/assets/images/icons/clip.svg")
              .button__text Добавить пункт

    section.profile-page-form__section.profile-section
      .profile-section__title
        h2.profile-section-title Площадки для спорта
      .profile-section__body
        .form
          .form__elem
            .form-elem.form-elem_horizontal
              .form-elem__title Название
              .form-elem__body
                input.input.input_full(
                maxlength="50"
                value="Басктебольная площадка"
                )
          .form__elem
            .form-elem.form-elem_horizontal
              .form-elem__title
              .form-elem__body
                input.input.input_full(
                maxlength="50"
                value="Волейбольная площадка"
                )
          .form__elem.form__elem--align-right
            button.button.button_paint-main--light
              //.button__icon
                img(src="@/assets/images/icons/clip.svg")
              .button__text Добавить пункт

      section.form__elem.form__elem--align-right.form__elem_full
        button.button.button_paint-main.button_long
          .button__text Сохранить

</template>

<script>
export default {
  name: "OperatorCampPlacement",
  data() {
    return {
      operatorPageData: {
        title: "О лагере",
        description: ""
        // "Здесь вы можете изменить данные своего профиля, следить за статусом заявки, а так же загрузить все необходимы для подачи заявки документы и информацию о детях"
      },
      campTypeList: [
        {
          text: "Деревянный",
          value: true
        },
        {
          text: "Кирпичный",
          value: false
        }
      ]
    };
  }
};
</script>
